module.exports = __webpack_public_path__ + "public/images/monster-1.fbbc0d3568456227892f722db06ac100.png";